import React from "react";
import ReactTooltip from "react-tooltip";
import tool_tip from "../../images/tool_tip.svg";

const ToolTip = (props) => (
  <>
    <span
      data-tip={props.tooltip_message}
      data-place={props.position}
      data-class="tool-tip"
    >
      <img src={props.icon ? props.icon : tool_tip} alt="tool tip icon" />
    </span>
    <ReactTooltip />
  </>
);

export default ToolTip;
